module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("ARTHUR CHRISTMAS")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Ever wondered how Santa became Santa? Well, welcome to the world of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthur Christmas")]), _vm._v(" – where Santahood is handed down generation after generation to those who are not just worthy but ready. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthur Christmas")]), _vm._v(" is a modern folk-tale about technology, knowing your strengths and weaknesses, and good old-fashioned teamwork. As such, it could well be the perfect Xmas movie. But how well do you know this 2011 animation? Let’s find out …")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('h3', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("20 Questions")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("1.")]), _vm._v(" How many missions does a Santa usually undertake before passing on the title?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" 70")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" 100")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" 25")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("2.")]), _vm._v(" There have been a number of Santas before Malcolm. So what number Santa is he in the tradition?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" 5")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" 20")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" 200")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("3.")]), _vm._v(" What are the names of Malcolm and his wife Margaret’s two kids?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" Adam and Steve")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Arthur and Martha")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Arthur and Steve")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("4.")]), _vm._v(" What is Steve’s role in the operation?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" He is in charge of Mission Control at the North Pole")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" He is in charge of matching up spare socks")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" He has to clean up all the reindeer poo")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("5.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("And what about Arthur – what’s his job at the start of the movie?")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" Dance instructor to the Elves")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Head of the First Order")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Replying to kids’ letters to Santa")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("6.")]), _vm._v(" What happens when an elf accidentally presses a button?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" The S-1 explodes")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" A present falls off the supply line")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Santa turns purple and floats away")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("7.")]), _vm._v(" What is the name of the girl who is supposed to receive that present?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" Glas")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Gwyn")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Gwen")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("8.")]), _vm._v(" And where does she live?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" Trelew, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Maesgeirchen, Bangor")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Bigtown, Giantland")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("9.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Why won’t Steve use the S-1 to deliver the missing gift?")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" He says it is out of petrol")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" He says one gift out of billions is an acceptable mistake")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" He does not like Gwen")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("10.")]), _vm._v(" Who comes to the rescue – or so he thinks?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" Grandsanta")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Grandstand")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Great Scott")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("11.")]), _vm._v(" Where does Arthur end up, though?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" The Isle of Man")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" An island in Cuba")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" At the South Pole")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("12.")]), _vm._v(" Steve does eventually take the S-1 to deliver a present – but what has he done wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" He forgot that his feet were really stinky")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" He forgot to lock the back door and all the snow came in")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" He set the address to the wrong place, so the wrong kid got the present")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("13.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Arthur, Grandsanta and the elf Bryony do reach England – but what happens to the sleigh?")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" It is destroyed by a drone, because it is mistaken for an alien spaceship")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" It falls to pieces because Grandsanta forgot to use washers when he was constructing it")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Nothing – it is magic so impervious to any damage")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("14.")]), _vm._v(" How do Arthur and Bryony escape?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" They take a magic bicycle ride with a passing wrinkly alien")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" They click their heels together and make a wish")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" They parachute to the ground safely")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("15.")]), _vm._v(" How do all the Clauses realise that Arthur deserves to be the new Santa?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" He fights them all with his special new powers")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" He has given them all a Christmas bonus of £19")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" He was the only one that cared about Gwen’s Christmas")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("16.")]), _vm._v(" Gwen sees Arthur briefly, and he seems to have a beard – how so?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" It is made of snow")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Arthur has stuck cotton wool to his face")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Gwen needs glasses")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("17.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("At the very end, what is Steve’s new job?")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" Resident Cookie Eater")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Chief Operating Officer")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Chief of Police")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("18.")]), _vm._v(" And how about the elf, Bryony Shelfley?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" Minister of Funk (Bootsy Baby)")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Prime Monster (North Pole)")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Vice-President of Wrapping (Pacific Division)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("19.")]), _vm._v(" What is the S-1 now called?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" EVIE")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" STEVIE")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" EFFOFF")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("20.")]), _vm._v(" Who sings the version of ‘Santa Claus is Coming to Town’ that plays over the final credits?")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("a.")]), _vm._v(" David Hasselhoff")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("b.")]), _vm._v(" Jar-Jar Binks and the Jedi")]), _vm._v(" "), _c('p', {
    staticClass: "list1"
  }, [_c('span', {
    staticClass: "list1"
  }, [_vm._v("c.")]), _vm._v(" Justin Bieber")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Answers on ")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter41#page_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 266")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99293496","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Chapter01.vue
// module id = 72
// module chunks = 0